import { Ear, PenTool, Palette, MessageCircle } from 'lucide-react';

const ApproachSection = () => {
  const approaches = [
    {
      icon: Ear,
      title: 'We Listen First',
      description:
        'Every project begins with understanding your vision, lifestyle, and how you use your space.',
    },
    {
      icon: PenTool,
      title: 'We Plan Carefully',
      description:
        'Detailed proposals ensure you know exactly what to expect before any work begins.',
    },
    {
      icon: Palette,
      title: 'We Style Intentionally',
      description:
        'Every element is chosen with purpose, creating cohesive spaces that reflect your personality.',
    },
    {
      icon: MessageCircle,
      title: 'We Communicate Clearly',
      description:
        'Transparent updates throughout the project keep you informed every step of the way.',
    },
  ];

  return (
    <section data-testid="approach-section" className="section-padding bg-white">
      <div className="container-main">
        {/* Split Layout */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Image Side */}
          <div className="order-2 lg:order-1">
            <div className="relative">
              <div className="image-hover-zoom">
                <img
                  src="https://images.unsplash.com/photo-1618221195710-dd6b41faaea6?auto=format&fit=crop&w=1200&q=80"
                  alt="Interior design consultation"
                  className="w-full h-[500px] object-cover"
                />
              </div>
              {/* Floating Card */}
              <div className="absolute -bottom-8 -right-8 bg-[#FAF9F6] p-6 shadow-xl max-w-xs hidden md:block">
                <p className="font-accent text-lg italic text-[#4A4A4A] leading-relaxed">
                  "Creating spaces that tell your story, one room at a time."
                </p>
              </div>
            </div>
          </div>

          {/* Content Side */}
          <div className="order-1 lg:order-2">
            <span className="text-xs uppercase tracking-[0.3em] text-[#C5A065] mb-4 block">
              Our Philosophy
            </span>
            <h2
              data-testid="approach-title"
              className="font-heading text-3xl md:text-4xl text-[#2D2D2D] mb-8"
            >
              A Thoughtful Approach to Home Decoration
            </h2>

            <div className="space-y-8">
              {approaches.map((item, index) => (
                <div
                  key={index}
                  data-testid={`approach-item-${index}`}
                  className="flex gap-5"
                >
                  <div className="flex-shrink-0">
                    <div className="w-12 h-12 rounded-full bg-[#FAF9F6] flex items-center justify-center">
                      <item.icon className="w-5 h-5 text-[#C5A065]" />
                    </div>
                  </div>
                  <div>
                    <h3 className="font-heading text-lg text-[#2D2D2D] mb-2">
                      {item.title}
                    </h3>
                    <p className="text-[#6E6E6E] text-sm leading-relaxed">
                      {item.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ApproachSection;
